import React, { useState, useEffect } from 'react';
import divider from '../../assets/divider-img.png';

const HomeTestimonial = () => {
  const projects = [
    {
      projectName: 'Project One',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis n',
      client: 'Client Name',
    },
    {
      projectName: 'Project Two',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis n',
      client: 'Client Name',
    },
    {
      projectName: 'Project Three',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis n',
      client: 'Client Name',
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentSlide((prevSlide) =>
          prevSlide < projects.length - 1 ? prevSlide + 1 : 0
        );
      }
    }, 2500);

    return () => clearInterval(interval);
  }, [isHovered, projects.length]);

  //   const handlePrevSlide = () => {
  //     setCurrentSlide((prevSlide) =>
  //       prevSlide > 0 ? prevSlide - 1 : projects.length - 1
  //     );
  //   };

  //   const handleNextSlide = () => {
  //     setCurrentSlide((prevSlide) =>
  //       prevSlide < projects.length - 1 ? prevSlide + 1 : 0
  //     );
  //   };

  return (
    <div className="home-testimonial">
      <div className="container">
        <div className="testimonial-wrapper">
          <div className="testimonial-left">
            <h2>
              We Help To Achieve <br /> Mutual Goals
            </h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              At Quantome, we believe in the power of collaboration. We work
              hand in hand with our clients to align our efforts and expertise,
              forging a strong partnership to achieve shared objectives. With
              over 759+ projects completed and 100+ active clients, we are a
              trusted partner in the trading community.
            </p>
            <div className="testimonial-count">
              <div className="count-info count-info-ml">
                <h2>759+</h2>
                <h5>Projects Done</h5>
              </div>
              <div className="count-info">
                <h2>100+</h2>
                <h5>Active Clients</h5>
              </div>
            </div>
          </div>
          <div className="testimonial-right">
            <div
              className="custom-slider"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div className="testi-slider-content">
                <h4>{projects[currentSlide].projectName}</h4>
                <p>{projects[currentSlide].description}</p>
                <h5>{projects[currentSlide].client}</h5>
              </div>
              <div className="slider-navigation">
                {/* <button
                  className="slider-button prev"
                  onClick={handlePrevSlide}
                >
                  &lt;
                </button>
                <button
                  className="slider-button next"
                  onClick={handleNextSlide}
                >
                  &gt;
                </button> */}
              </div>
            </div>

            <div className="slider-dots">
              {projects.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTestimonial;
